import React, { useState } from 'react';
import Layout from '../components/Layout';
import { applicationService } from '../services/firebaseService';

const VolunteerPage: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const submitForm = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      await applicationService.submitApplication('volunteer', { name, email, phone, message });
      setStatus('success');
      setName(''); setEmail(''); setPhone(''); setMessage('');
    } catch (err) {
      setStatus('error');
    }
  };
  return (
    <Layout>
      <div className="container">
        <h1>Get Involved</h1>
        <p>Join our mission as a volunteer...</p>
        <form onSubmit={submitForm} style={{ maxWidth: 600 }}>
          <div className="form-group">
            <label className="form-label" htmlFor="name">Full Name</label>
            <input id="name" className="form-input" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="email">Email</label>
            <input id="email" type="email" className="form-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="phone">Phone</label>
            <input id="phone" className="form-input" value={phone} onChange={(e) => setPhone(e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="message">Message</label>
            <textarea id="message" className="form-textarea" value={message} onChange={(e) => setMessage(e.target.value)} rows={4} />
          </div>
          <button className="btn btn-primary" disabled={status==='submitting'}>
            {status==='submitting' ? 'Submitting...' : 'Submit'}
          </button>
        </form>
        {status==='success' && <div className="success">Thanks! Your application has been submitted.</div>}
        {status==='error' && <div className="error">Something went wrong. Please try again.</div>}
      </div>
    </Layout>
  );
};

export default VolunteerPage;
